export enum TransactionType {
  TEXTMESSAGE = "TEXTMESSAGE"
}